import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "-45px",
    zIndex: 2,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginTop: "-25px",
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  containerSearch: {
    backgroundColor: "#0073cf",
    width: 500,
    height: 80,
    padding: "45px 30px 20px 30px",
    borderRadius: 8,
    [theme.breakpoints.down("sm")]: {
      width: 300,
      padding: "30px 30px 30px 30px"
    },
    [theme.breakpoints.down("xs")]: {
      height: 50
    }
  },
  linkStyle: {
    color: "#ffffff",
    fontSize: 12,
    fontFamily: "Trebuchet",
    letterSpacing: 0,
    textDecoration: "none !important",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  input: {
    color: "#333333",
    fontFamily: "Trebuchet",
    fontSize: 14,
    borderRadius: 8,
    width: "94%",
    height: 30,
    border: "1px solid #aaa",
    padding: " 5px 15px",
    [theme.breakpoints.down("xs")]: {
      padding: " 5px 10px"
    }
  },
  inputFocused: {
    outline: "none"
  },
  inputOpen: {
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0"
  },
  container: {
    position: "relative"
  },
  suggestionsContainer: {
    display: "none",
    background: "#ffffff",
    borderRadius: 8
  },
  suggestionsContainerOpen: {
    display: "block",
    position: "absolute",
    top: "40px",
    width: "100%",
    border: "1px solid #aaa",
    backgroundColor: "#ffffff",
    fontFamily: "Helvetica, sans-serif",
    fontWeight: 300,
    fontSize: "16px",
    borderRadius: " 0px 0px 8px 8px",
    zIndex: 2
  },
  suggestionsList: {
    margin: "0",
    padding: "0",
    listStyleType: "none"
  },
  suggestion: {
    cursor: "pointer",
    padding: "10px 20px"
  },
  suggestionHighlighted: {
    backgroundColor: "#ddd"
  }
}));

export default styles;
